import React from "react";
import { FaChartBar, FaClipboardList, FaSearch, FaSlidersH, FaFileAlt, FaFilter } from "react-icons/fa";
import "./TallyFieldPage.css";

const ReportDesign = () => {
  const sections = [
    {
      title: "Powerful Dashboards",
      content: "Unlock data visualization with dashboards designed for instant insights. Monitor KPIs, trends, and comparisons in real-time.",
      icon: <FaChartBar />,
    },
    {
      title: "Instant Insights",
      content: "Get accurate, actionable reports at the blink of an eye. TallyPrime enables quick decision-making with in-depth data views.",
      icon: <FaClipboardList />,
    },
    {
      title: "Deep Data Analysis",
      content: "Built-in designs crafted to help you make better decisions. Use powerful filters and customizations for personalized analysis.",
      icon: <FaSearch />,
    },
    {
      title: "Easy Navigation",
      content: "An intuitive interface with quick search and seamless navigation ensures a smooth experience while working with complex reports.",
      icon: <FaSlidersH />,
    },
    {
      title: "Personalized Layouts",
      content: "Personalize your reports by choosing data views, filters, and visual layouts that suit your specific business requirements.",
      icon: <FaFileAlt />,
    },
    {
      title: "Advanced Filtering",
      content: "Apply multi-layered filters to get refined insights. The reports are dynamic and adapt to your preferences instantly.",
      icon: <FaFilter />,
    },
  ];

  return (
    <div className="tally-field-page">
      <div className="tally-field-container">
        <header className="tally-field-header">
          <span className="subtitle">Core Feature</span>
          <h1>Insightful Reports</h1>
          <p>Make informed decisions with powerful, customizable business reports.</p>
        </header>

        <div className="tally-field-grid">
          {sections.map((section, index) => (
            <div className="tally-field-card" key={index}>
              <div className="icon-wrapper">
                {section.icon}
              </div>
              <div className="card-content">
                <h3>{section.title}</h3>
                <p>{section.content}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ReportDesign;
